<template>
	<div id="wrapper" class="pb-5 mb-5 bg-white h-100vh">
	    <div class="container">
	        <div class="row align-items-center justify-content-center h-100">
	            <div class="col-12 col-lg-6">
	                <form class="customFotm" @submit.stop.prevent="submit()">
	                    <div class="imgcontainer text-center mb-4">
	                        <img src="../../../../static/website/images/logo.svg" alt="Logo" class="avatar">
	                    </div>
	                    <div class="loginElement position-relative">
	                    	<loader v-if="pageLoader"></loader>
	                        <h2 class="text-center mb-4">Welcome back to <span class="themecolor">gini</span></h2>
	                        <div class="form-group">
	                            <label for="uname">Email Address</label>
	                            <div class="position-relative inputIcon">
	                                <input type="text" placeholder="" name="email" v-model="email" class="form-control" v-validate="'required|email'">
	                                <span class="iconInput"><feather type="user"></feather></span>
	                            </div>
	                            <span class="text-danger" v-if="submitted && errors.has('email')">{{ errors.first('email') }}</span>
	                        </div>
	                        <div class="form-group">
	                            <button class="btn btn-link btn-blue w-100" v-on:click.prevent="submit()">Submit</button>
	                            <!-- <a href="book-appointment.html" class="btn btn-link btn-blue w-100" type="submit">Login</a> -->
	                        </div>
	                        <div class="form-group mb-0 text-center mt-3">
	                            <p class="mb-0">Back to Login <router-link to="/">Login here</router-link></p>
	                        </div>
	                    </div>
	                </form>
	            </div>
	        </div>
	    </div>
	</div>
</template>
<script>
    import * as types from '@/types'
    import { mapActions } from 'vuex'
    //import { fxViewMixins } from '@/plugins/fxView'
    export default {
        name: 'Forgot-password',
        //mixins: [fxViewMixins],
        data() {
            return {
                "email" : "",
				resend : false,
                submitted: false,
                pageLoader : false,
                response_msg : '',
                msg_type   : '',      
            }
        },
		components: {
        },
        methods:{
            ...mapActions({
                _runForgotPassword: types.RUN_FORGOT_PASSWORD
            }),
            submit(){
                const _that = this
                _that.submitted = true;
                _that.$validator.validate().then(valid => {
                    if (valid) {
                        let input_json={
                            'globalParams' :{
                                "email": _that.email
                            },
                            'localParams' :{ "parameter" : _that }
                        }
                        _that._runForgotPassword(input_json)
                    }else{
                        _that.handleValidationErrorAdvanced(_that.errors)
                    }
                });
            }
        }
    }
</script>


// WEBPACK FOOTER //
// src/components/website/user/forgot_password.vue